export default "__VITE_PUBLIC_ASSET__6b95e8c7__"